import { ReactComponent as InfoIcon } from "../../../assets/icons/info-icon-filled.svg";
import RenderVariantComponent from "./RenderVariantComponent";
import SelectedAttrComponent from "./SelectedAttrComponent";
import { AppInputDropDown } from "../../../Libraries";
import StockDropDownInput from "./StockDropDownInput";
import LineText from "../../../Libraries/LineText";
import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  validateAttributeOptions,
  VariantsData,
} from "../../../constants/variantConstants";
import styles from "./styles.module.css";

const VariantDropdown = ({
  options = Object.keys(VariantsData),
  allAttributes = [],
  placeholder = "",
  setIsEditMode,
  label = "",
  isEditMode,
  selectedAttributes = {
    keyId: "",
    attrOptions: [],
  },
  handleSaveAttributeOptions = (key, newVal) => { },
  isFromEditFlow = false,
  varianData,
  stock,
  disabled=false,
  ...props
}) => {

  const [currentSelected, setCurrentSelected] = useState(selectedAttributes?.keyId || null);
  const [attrErr, setAttrErr] = useState(false);

  const editMode = isEditMode || false;

  React.useEffect(() => {
    const isAlreadyInAttrs = allAttributes
      .map((x) => x?.keyId)
      .includes(currentSelected);

    if (isAlreadyInAttrs && currentSelected !== selectedAttributes.keyId) {
      setAttrErr(true);
    } else {
      setAttrErr(false);
    }
  }, [allAttributes, isEditMode]);

  const handleSaveOptions = (key, options) => {
    if (!options.length) {
      handleSaveAttributeOptions("", options);
      return;
    }

    if (key === "" && options.length === 0) {
      setCurrentSelected("");
    }
    if (validateAttributeOptions(options)) {
      const isErr = handleSaveAttributeOptions(key, options);
      if (isErr !== "error") setIsEditMode(false);
    } else {
      toast.error(`Error! Duplicate Attribute Options`, {
        className: "errorToast",
        toastId: "err_duplicate_options",
      });
    }
  };

  return (
    <div className={`user-select-none marginTop20 ${styles.VariantDropdown}`}>
      {selectedAttributes?.attrOptions?.length &&
        currentSelected &&
        !editMode ? (
        <SelectedAttrComponent
          keyId={selectedAttributes?.keyId}
          handleEdit={setIsEditMode.bind(this, true)}
          attributes={selectedAttributes?.attrOptions}
          editDisabled={disabled}
          {...props}
        />
      ) : (
        <>
          <div className='d-flex align-items-center justify-content-end'>
            <div className='d-flex align-items-center gap-1' id='label-info'>
              <InfoIcon />
              <LineText className='fontSize12'>{label}</LineText>
            </div>
          </div>
          <AppInputDropDown
            data={{
              value: currentSelected || "",
              onChangeText: (v, select) => {
                setAttrErr(false);
                if (select !== selectedAttributes.keyId) {
                  const isAlreadyInAttrs = allAttributes
                    .map((x) => x?.keyId)
                    .includes(select);

                  if (isAlreadyInAttrs) {
                    setAttrErr(true);
                    setCurrentSelected(select);
                  } else setCurrentSelected(select);

                  return;
                }
                setCurrentSelected(select);
                return;
              },
              list: options,
              fromEdit: isFromEditFlow,
            }}
            RenderInput={(params) => (
              <StockDropDownInput
                params={params}
                placeholder={placeholder}
                className={`variant_dropdown_select ${attrErr ? "same_attribute_err" : ""
                  } ${isFromEditFlow ? "variant_disabled_class" : ""}`}
                disabled={isFromEditFlow ? true : false}
              />
            )}
            filterOptions={(op, { inputValue }) => op.filter((v) => true)}
            className={"p-0"}
          />
          {attrErr ? (
            <LineText className='error_paragraph'>
              {currentSelected} is already created
            </LineText>
          ) : (
            <LineText>&nbsp;</LineText>
          )}
          {(currentSelected && !selectedAttributes?.attrOptions?.length) ||
            editMode ? (
            <RenderVariantComponent
              handleSave={(key, options) => handleSaveOptions(key, options)}
              closeEdit={setIsEditMode.bind(this, false)}
              attr={selectedAttributes?.attrOptions}
              isFromEditFlow={isFromEditFlow}
              keyId={currentSelected}
              varianData={varianData}
              stock={stock}
            />
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
};

export default VariantDropdown;
